module.exports = __webpack_public_path__ + "assets/6e27ce85830569472948d7b89eea3cb4.mp4";